/* eslint-disable object-shorthand */
/* eslint-disable vars-on-top */
/* eslint-disable no-var */
/* eslint-disable no-else-return */
/* eslint-disable no-useless-concat */
/* eslint-disable no-console */
/* eslint-disable prefer-template */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import React from 'react'
import { Link } from 'react-router-dom'
import MetaTags from 'react-meta-tags' 
import ContentLoader from "react-content-loader"; 
import Axios from 'axios'
import * as myConstClass from '../../../constants/Constants'

class Market extends React.Component<any, any> {

  constructor(props)
  {
    super(props);
    this.state = {      
        markets_list_data: [],
        exchanges_ids: myConstClass.exchange_list,
        api_base_url: myConstClass.api_base_url,
        image_base_url:"",
        latestcoin_data:[],  
        usdpricetoken: [],
        volumepricetoken: [],
    } 
  }

  componentDidMount()
  {   

    // this.latestcoins();

    Axios.get("https://api.coingecko.com/api/v3/exchanges/binance")
    .then(response=>{     

      const markets_lists_data: any = [];
      const exchange_list : any = [];

      const {exchanges_ids} = this.state

      exchanges_ids.map((e)=>{ 
        response.data.tickers.map((item)=>{
          if(e.id === item.coin_id){
            if(exchange_list.indexOf(item.coin_id) === -1){ 
              const  obj = {id: e.id, symbol: e.symbol, image: e.image, volume: item.volume, last: item.last }  
              markets_lists_data.push(obj)  
              exchange_list.push(e.id)
              console.log(markets_lists_data)
              console.log(exchange_list)
            }
          }    
        })
      }) 
 
      this.setState({markets_list_data: markets_lists_data}) 
    })  
    
  }


  get24hVolume(contractaddress: any, token: any) { 

    const dateSince = ((new Date(Date.now() - 24 * 60 * 60 * 1000)).toISOString())
    const query = `
                query
                {
                  ethereum(network: bsc) {
                    dexTrades(
                      date: {since: "` + dateSince + `"}
                      baseCurrency: {is: `+ '"' + contractaddress + '"' + `}
                      options: {desc: "tradeAmount"}
                    ) {
                      tradeAmount(in: USD)
                    }
                  }
                }
          ` ;

    const url = "https://graphql.bitquery.io/";
    const opts = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": "BQYAxReidkpahNsBUrHdRYfjUs5Ng7lD"
      },
      body: JSON.stringify({
        query
      })
    };

    fetch(url, opts)
      .then(res => res.json())
      .then(result => { 
        if(result.data.ethereum.dexTrades[0].tradeAmount){
          this.setState(prevState => ({
            volumepricetoken: [...prevState.volumepricetoken, {value: result.data.ethereum.dexTrades[0].tradeAmount,token: token}]
          })) 
        } 
      })
      .catch(console.error);  
  }
  
  
  async getTokenUsdPrice(contractaddress: any, token: any) {  

    const dateSince = ((new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).toISOString())
    const query = `
                query
                {
                  ethereum(network: bsc) {
                    dexTrades(
                      date: {since: "` + dateSince + `"}
                      any: [{baseCurrency: {is: `+ '"' + contractaddress + '"' + `}, quoteCurrency: {is: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c"}}, {baseCurrency: {is: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c"}, quoteCurrency: {is: "0xe9e7cea3dedca5984780bafc599bd69add087d56"}}]
                      options: {desc: ["block.height"], limitBy: {each: "baseCurrency.symbol", limit: 1}}
                    ) {
                      baseCurrency {
                        symbol
                      }
                      block {
                        height
                      }
                      transaction {
                        index
                      }
                
                      quoteCurrency {
                        symbol
                      }
                      quote: quotePrice
                    }
                  }
                }
          ` ;

    const url = "https://graphql.bitquery.io/";
    const opts = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": "BQYAxReidkpahNsBUrHdRYfjUs5Ng7lD"
      },
      body: JSON.stringify({
        query
      })
    }; 
    await fetch(url, opts)
      .then(res => res.json())
      .then(result => {    

        if(result.data.ethereum.dexTrades[0].quote * result.data.ethereum.dexTrades[1].quote){
          this.setState(prevState => ({
            usdpricetoken: [...prevState.usdpricetoken, {value: result.data.ethereum.dexTrades[0].quote * result.data.ethereum.dexTrades[1].quote,token: token}]
          })) 
        }
      })
      .catch(console.error);   
  }

  latestcoins() {
    const { api_base_url} = this.state; 

    fetch(api_base_url + "tokens/list", {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": "234ADSIUDG98669DKLDSFHDASDFLKHSDAFIUUUUS"
      },
      
    }).then(res => res.json())
      .then(
        (result) => { 
          if (result.status === true) {  
            this.setState({ latestcoin_data: result.message }) 
            this.setState({image_base_url: result.image_base_url}) 
            console.log(result.message)
            if(result.message.length > 0){
              result.message.map((e: any)=>{
               this.getTokenUsdPrice(e.contract_address, e.coin_symbol) 
               this.get24hVolume(e.contract_address, e.coin_symbol)
              })
            }
          }
        }); 
  }
 
  render()
  {
    const {markets_list_data, image_base_url, latestcoin_data, volumepricetoken, usdpricetoken } = this.state 
    return (
      <>   
      {console.log(volumepricetoken)}
      {console.log(usdpricetoken)}
      <div id="Content" className="markets_list_page market_page_element">
      <MetaTags>
          <title>Markets - Decentralized Exchange | DEX </title>
          <link rel="canonical" href="https://arrano.network/" />
          <meta name="description" content=" Arrano Network is a powerful and user-friendly decentralized exchange developed by the Arrano Developers community. Arrano DEX..." />
          <meta name="keyword" content="Arrano Network, Arrano DEX, ANO Token, Arrano Tokens, Arrano DeFi, Arrano airdrop , ANO Defi token , Arrano Network Community , Arrano Launchpad, Arrano Exchange Arrano Defi Project , ANO governance token" />
          <meta property="og:title" content="Markets - Decentralized Exchange | DEX" />
          <meta property="og:image" content="/bsc_logo.png" />
        </MetaTags> 
        
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="spread_sheet_two" />
                <h4 className="market_title">DeFi Tokens</h4>
                <p className="defi_token_para">Live market price and token details.</p>
              </div>

              {/* <div className="col-md-4">
                <Link to="/market/list-your-coin" className="list_coin_button">List your Coin</Link>
              </div> */}
            </div>
 
            <div className="main_block_market">
              <div className="row">
                <div className="col-md-12">   
                
                  <ul className="nav nav-tabs default_an_tabs">
                    <li className="nav-item">
                      <a className="nav-link active" data-toggle="tab" href="#coin">Coins</a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" data-toggle="tab" href="#coinlisted">Recent Listed Coins</a>
                    </li>
                  </ul>

                  <div className="tab-content">
                  
                  <div className="tab-pane active" id="coin">
                  <div className="row">
                    {
                      markets_list_data.length > 0 ?
                      <>
                      { 
                        markets_list_data.map((item) => {
                          return <div className="col-md-3">
                          {/* eslint-disable-next-line prefer-template */}
                            <Link to={"/market/"+item.symbol.toUpperCase()}>
                              <div className="main_market_display market_list_coins">
                                <h4 style={{textTransform:"capitalize"}}>{item.id} <span style={{textTransform:"uppercase"}}>{item.symbol}</span></h4>
                                <p>Vol: {parseFloat(item.volume).toFixed(2)}</p>  
                                <img src={'/assets/images/market_tokens/'+item.symbol + '.svg'} alt={item.symbol} className="" />
                                <h6>$ {item.last}</h6>
                              </div>
                            </Link>
                          </div>
                        }) 
                      }
                      </>
                      :
                      <>
                        <div className="row">
                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                            </>
                          }
                      </div>
                    </div>
                    <div className="tab-pane" id="coinlisted">
                      <div className="row">
                        
                      {
                      latestcoin_data.length > 0 ?
                      <>
                      { 
                        latestcoin_data.map((item: any) => {
                          return <div className="col-md-3">
                          {/* eslint-disable-next-line prefer-template */}
                            <Link to={"/market/bsc/"+item.contract_address}>
                              <div className="main_market_display">
                                <div className="media">
                                  <div className="media-body">
                                    <h4 style={{textTransform:"uppercase"}}>{item.coin_symbol}</h4>  
                                    {
                                      usdpricetoken.find(e => e.token === item.coin_symbol)
                                      ?
                                      <h6>$ {usdpricetoken.map((e: any)=>{ return <>{e.token === item.coin_symbol ? parseFloat(e.value).toFixed(6) : null}</>} )}</h6>
                                      :
                                      <h6>$ 0</h6>
                                    } 
 
                                    {
                                      volumepricetoken.find(e => e.token === item.coin_symbol)
                                      ?
                                      <p>Vol: {volumepricetoken.map((e: any)=>{ return <>{e.token === item.coin_symbol ? parseFloat(e.value).toFixed(6) : null}</>} )}</p>
                                      :
                                      <p>Vol: 0</p>
                                    }   
                                  </div> 
                                  <img src={image_base_url+item.coin_image} alt={item.symbol} className="ml-3" />
                                </div>
                              </div>
                            </Link>
                          </div>
                        }) 
                      }
                      </>
                      :
                      <>
                        <div className="row">
                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="main_market_display">
                              <div className="media">
                                <div className="media-body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="30%" height="10px" />
                                        <rect x="0" y="15" rx="0" width="50%" height="20px" />
                                        <rect x="0" y="40" rx="0" width="60%" height="10px" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-md-4">
                                      <ContentLoader speed={1}
                                        backgroundColor="#ABB0B2" foregroundColor="#ecebeb"  className="content_rewards" width="100%" height="50px">
                                        <rect x="0" y="0" rx="0" width="100%" height="50px" />
                                        
                                      </ContentLoader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                            </>
                          }
                        

                        
                      </div>
                      
                    </div>
                  </div>

                
                </div>
              </div>
            </div>
          </div>
        </div>
        </>
    );
  }
}

export default Market;
